module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "pricing-details p-3 bg-lightest"
  }, [_c('table', {
    staticClass: "table bare details"
  }, [_c('tr', [_c('td', {
    staticClass: "bold"
  }, [_vm._v("Taxes")]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(_vm.formatPrice(_vm.taxesPriceTotal + _vm.extrasTaxPriceTotal)) + "€\n\n                    "), (_vm.product.includeTaxes) ? _c('span', [_vm._v("(included)")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "totals bg-color-1 py-3 mb-3"
  }, [_c('table', {
    staticClass: "table bare"
  }, [_c('tr', [_c('td', [_vm._v("Total")]), _vm._v(" "), _c('td', {
    staticClass: "bold fs-largest"
  }, [_vm._v("\n                    " + _vm._s(_vm.formatPrice(_vm.finalPrice)) + "€\n                ")])]), _vm._v(" "), (_vm.chosenPayment && _vm.chosenPayment.id !== 1 && _vm.chosenDeposit) ? _c('tr', [_c('td', [_vm._v("Deposit")]), _vm._v(" "), _c('td', {
    staticClass: "fs-large"
  }, [(_vm.chosenDeposit.id > 0) ? _c('span', [_vm._v("\n                        " + _vm._s(_vm.formatPrice(_vm.product.paymentValue)) + "€\n                    ")]) : _c('span', [_vm._v("\n                        " + _vm._s(_vm.product.paymentValue) + "% (" + _vm._s(_vm.formatPrice(_vm.deposit)) + "€)\n                    ")])])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Outstanding amount")]), _vm._v(" "), _c('td', {
    staticClass: "fs-large"
  }, [_vm._v("\n                    " + _vm._s(_vm.formatPrice(_vm.outstanding)) + "€\n                ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d634c4c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/summary/SummaryTotals.vue
// module id = 2422
// module chunks = 0